import { twMerge } from "tailwind-merge";
import Link from "next/link";
import { ImageOrientation } from "@/api/nfts/types";
import { Image } from "@/shared/types";
import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";
import { DEFAULT_NFT_SIZE } from "@/shared/constants";

const ImageSizeVariants = {
  [ImageOrientation.Squared]: "sm:max-w-[628px]",
  [ImageOrientation.Landscape]: "sm:max-h-[600px]",
  [ImageOrientation.Portrait]: "sm:max-w-[500px]",
};

export interface Props {
  id: string;
  image: Image;
  name: string;
  swap?: boolean;
}

const ArtworkItemImage = ({ id, name, image, swap = false }: Props) => {
  return (
    <Link
      href={`/nft/${id}`}
      className={`relative block ${
        image.orientation == ImageOrientation.Portrait ? "w-full" : "w-[90%]"
      } sm:w-1/2`}
    >
      <span
        className={`w-full h-full ${
          image.orientation == ImageOrientation.Portrait && "absolute sm:hidden"
        } bg-gradient-to-b from-transparent to-black/[.6]`}
      />
      <ImageTypeHandler
        src={image.src}
        placeholder={image.placeholder}
        type={image.type}
        alt={name}
        width={image.width || DEFAULT_NFT_SIZE}
        height={image.height || DEFAULT_NFT_SIZE}
        className={twMerge(
          `w-full  ${ImageSizeVariants[image.orientation]}`,
          swap ? "object-right" : "object-left",
        )}
        grid
      />
    </Link>
  );
};

export default ArtworkItemImage;
